import { motion } from '~/lib/motion'
import { m } from '~/paraglide/messages'

/**
 * Floating "Jump" pill fixed above the final-rewards footer, centered on
 * the progress track. The caller wraps it in AnimatePresence and shows it
 * while a purchasable jump point pill is out of the viewport; tapping
 * scrolls the page to the pills.
 */
export function JumpAnchor(props: { onClick: () => void }) {
  return (
    <motion.div
      className="pointer-events-none fixed bottom-[160px] left-0 right-0 z-10 flex justify-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.button
        className="pointer-events-auto relative"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 2, ease: 'easeInOut', repeat: Infinity }}
        onClick={props.onClick}
      >
        <span
          className="flex items-center justify-center rounded-[20px] border-[3px] border-transparent p-2 text-xs font-black leading-none text-[#458B99]"
          style={{
            background:
              'linear-gradient(#fff, #fff) padding-box, linear-gradient(137deg, #FFEAAF 15.4%, #D6FFF5 59.6%, #7EF7DB 100%) border-box',
            boxShadow: '0 -2px 9.3px 3px rgba(151, 233, 210, 0.70)',
          }}
        >
          {m.jump_progress_anchor()}
        </span>
        <PennantTail className="absolute -bottom-0.5 left-1/2 -z-10 -translate-x-1/2" />
      </motion.button>
    </motion.div>
  )
}

function PennantTail(props: { className?: string }) {
  return (
    <svg
      className={props.className}
      width="13"
      height="7"
      viewBox="0 0 13 6.83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.50012 0H13L13 3L7.88675 6.40882C7.047 6.96865 5.953 6.96865 5.11325 6.40882L0 3L0.000122789 0H6.50012Z"
        fill="#C3FDF0"
      />
    </svg>
  )
}
